export const formatDateLong = (dateString: string): string => {
	if (!dateString) {
		return '';
	}
	const date = new Date(dateString);
	return date.toLocaleDateString('de-DE', {
		year: 'numeric',
		month: 'long',
		day: 'numeric'
	});
};

export const formatDateShort = (dateString: string): string => {
	if (!dateString) {
		return '';
	}
	const date = new Date(dateString);
	return date.toLocaleDateString('de-DE', {
		year: 'numeric',
		month: '2-digit',
		day: '2-digit'
	});
};

export const formatDateAuto = (dateString: string): string => {
	if (!dateString) {
		return '';
	}
	const hasTime = /T\d{2}:\d{2}/.test(dateString);
	const date = new Date(dateString);
	return date.toLocaleString('de-DE', {
		year: 'numeric',
		month: '2-digit',
		day: '2-digit',
		...(hasTime && { hour: '2-digit', minute: '2-digit' })
	});
};

export const formatNumber = (num: number): string => {
	return num.toLocaleString('de-DE');
};
